import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { ApiUrlContext } from "../App";

function HomePage() {
  const apiUrl = useContext(ApiUrlContext);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/courses`)
      .then((res) => res.json())
      .then((data) => {
        setCourses(data);
        setLoading(false);
      });
  }, [apiUrl]);

  if (loading) return (
    <div style={styles.loading}>
      <div style={styles.spinner}></div>
      <p>Yükleniyor...</p>
    </div>
  );

  return (
    <div style={styles.container}>
      {/* Başlık Bölümü */}
      <div style={styles.header}>
        <h1 style={styles.title}>Kurslar</h1>
        <p style={styles.subtitle}>
          Keşfetmek için kursları inceleyin
        </p>
      </div>

      {/* Kurs Grid */}
      <div style={styles.coursesGrid}>
        {courses.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyIcon}>📚</div>
            <div style={styles.emptyText}>
              Hiç kurs bulunamadı.
            </div>
          </div>
        ) : (
          courses.map(course => (
            <div
              key={course._id}
              style={styles.courseCard}
              className="course-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.05)";
              }}
            >
              {/* Kurs Görseli */}
              <img 
                src={course.image} 
                alt={course.title} 
                style={styles.courseImage}
              />
              
              {/* Kurs İçeriği */}
              <div style={styles.courseContent}>
                <h2 style={styles.courseTitle}>
                  {course.title}
                </h2>
                
                <div style={styles.instructor}>
                  {course.instructor}
                </div>
                
                <div style={styles.description}>
                  {course.description}
                </div>
                
                <div style={styles.categoryBadge}>
                  {course.category}
                </div>
              </div>

              {/* Butonlar */}
              <div style={styles.buttonsContainer}>
                <Link 
                  to={`/course/${course._id}`} 
                  style={{ flex: 1 }}
                >
                  <button style={styles.primaryButton}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#3a8a4a";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#42a947";
                  }}
                  >
                    Kursa Git
                  </button>
                </Link>
                
                <Link 
                  to={`/blog/${course._id}`} 
                  style={{ width: "60px" }}
                >
                  <button style={styles.forumButton}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#3a7a44";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#3a8a4a";
                  }}
                  >
                    Yorum
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    background: '#f7f7f7',
    minHeight: '100vh',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    color: '#333',
    fontSize: '14px',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #f3f3f3',
    borderTop: '3px solid #42a947',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '16px',
  },
  header: {
    marginBottom: '32px',
    textAlign: 'center',
  },
  title: {
    fontSize: '32px',
    fontWeight: 'bold',
    color: '#333',
    margin: '0 0 8px 0',
  },
  subtitle: {
    color: '#666',
    fontSize: '16px',
    margin: '0',
  },
  coursesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '24px',
  },
  emptyState: {
    gridColumn: '1 / -1',
    textAlign: 'center',
    padding: '48px 20px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #eee',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  },
  emptyIcon: {
    fontSize: '24px',
    color: '#666',
    marginBottom: '16px',
  },
  emptyText: {
    fontSize: '16px',
    color: '#555',
    fontWeight: '500',
  },
  courseCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #eee',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  },
  courseImage: {
    width: '100%',
    height: '180px',
    objectFit: 'cover',
    backgroundColor: '#f8f9fa',
  },
  courseContent: {
    padding: '20px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  courseTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: '0',
    lineHeight: '1.4',
  },
  instructor: {
    color: '#42a947',
    fontSize: '14px',
    fontWeight: '500',
  },
  description: {
    fontSize: '14px',
    color: '#555',
    lineHeight: '1.5',
    flex: 1,
  },
  categoryBadge: {
    background: '#f8f9fa',
    color: '#333',
    fontSize: '12px',
    padding: '4px 12px',
    borderRadius: '20px',
    fontWeight: '500',
    alignSelf: 'flex-start',
    border: '1px solid #e0e0e0',
  },
  buttonsContainer: {
    display: 'flex',
    borderTop: '1px solid #eee',
  },
  primaryButton: {
    width: '100%',
    border: 'none',
    background: '#42a947',
    color: '#ffffff',
    padding: '12px 0',
    fontWeight: '500',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background 0.2s ease',
  },
  forumButton: {
    width: '100%',
    border: 'none',
    background: '#3a8a4a',
    color: '#ffffff',
    padding: '12px 0',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.2s ease',
  },
};

// CSS Animasyonu
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

export default HomePage;
